<template>
    <div>
        <el-dialog title="订单信息" width="1300px" :visible="orderDialogVisible" @close="closeDialog" @open="openDialog"
                   :close-on-click-modal="false" fullscreen>
            <div>
                <div style="float: left">
                    <span style="font-weight: bold;font-size: 20px">{{dataView.incubatorName | langjson}}</span>
                    <span style="font-weight: bold;font-size: 20px">({{dataView.incubatorCoin}})</span><br>
                    <span style="padding-top: 5px;display: inline-block">{{dataView.updateTime | moment}}</span>
                </div>

                <div style="float: right">
                    <el-button type="primary" @click="msDialogVisible=true"
                               v-if="dataView.incubatorType=='SECKILL' && dataView.state<4">平台秒杀
                    </el-button>
                    <el-button type="primary" @click="tgDialogVisible=true"
                               v-if="dataView.incubatorType=='GROUPBUYING' && dataView.state<4">平台团购
                    </el-button>
                    <el-button type="danger" @click="checkIncubator()"
                               v-if="(dataView.incubatorType=='GROUPBUYING') && dataView.distributionType!='IMMEDIATE_DISTRIBUTION'">
                        检查
                    </el-button>
                    <el-button type="danger" @click="calculationIncubator()"
                               v-if="(dataView.incubatorType=='GROUPBUYING') && dataView.distributionType!='IMMEDIATE_DISTRIBUTION'">
                        核算
                    </el-button>
                    <el-button type="danger" @click="ffDialogVisible=true"
                               v-if="(dataView.incubatorType=='SECKILL' || dataView.incubatorType=='GROUPBUYING') && dataView.distributionType!='IMMEDIATE_DISTRIBUTION'">
                        发放代币
                    </el-button>
                </div>
            </div>

            <div style="margin-top: 80px;clear: both">
                <h1>实时概览 ({{dataView.incubatorType | incubatorTypeFormat}})</h1>
                <div style="border-bottom: 1px solid gainsboro"></div>
            </div>
            <el-form label-width="120px" inline>
                <el-form-item label="总量：" style="width: 400px"
                              v-if="dataView.incubatorType=='SECKILL' || dataView.incubatorType=='GROUPBUYING'">
                    {{dataView.totalAmount}}
                </el-form-item>
                <el-form-item label="实际总量：" style="width: 400px"
                              v-if="dataView.incubatorType=='SECKILL' || dataView.incubatorType=='GROUPBUYING'">
                    {{dataView.actualTotalAmount}}
                </el-form-item>
                <el-form-item label="当前总量：" style="width: 400px"
                              v-if="dataView.incubatorType=='SECKILL' || dataView.incubatorType=='GROUPBUYING'">
                    {{dataView.nowAmount}}
                </el-form-item>
                <el-form-item label="当前投入：" style="width: 400px" v-if="dataView.incubatorType=='INVESTMENT'">
                    {{dataView.nowAmount}}
                </el-form-item>
                <el-form-item label="支付币种：" style="width: 400px"
                              v-if="dataView.incubatorType=='SECKILL' || dataView.incubatorType=='GROUPBUYING'">
                    {{dataView.paymentCoin | arrFormat}}
                </el-form-item>
                <el-form-item label="优惠币种：" style="width: 400px"
                              v-if="dataView.incubatorType=='SECKILL' || dataView.incubatorType=='GROUPBUYING'">
                    {{dataView.discountCoin | arrFormat}}
                </el-form-item>
                <el-form-item label="当前进度：" style="width: 400px"
                              v-if="dataView.incubatorType=='SECKILL' || dataView.incubatorType=='GROUPBUYING'">
                    {{(dataView.currentProgress*100).toFixed(2)}}%
                </el-form-item>
                <el-form-item label="用户获得：" style="width: 400px"
                              v-if="dataView.incubatorType=='SECKILL' || dataView.incubatorType=='GROUPBUYING'">
                    {{dataView.userAmount}}
                </el-form-item>
                <el-form-item label="平台获得：" style="width: 400px"
                              v-if="dataView.incubatorType=='SECKILL' || dataView.incubatorType=='GROUPBUYING'">
                    {{dataView.platformAmount}}
                </el-form-item>
                <el-form-item label="剩余数量：" v-if="dataView.incubatorType=='SECKILL'" style="width: 400px">
                    {{dataView.surplusAmount}}
                </el-form-item>
                <el-form-item label="待注入：" v-if="dataView.incubatorType=='GROUPBUYING'" style="width: 400px">
                    {{dataView.toBeInjected}}
                </el-form-item>
                <el-form-item label="发币账户余额：" style="width: 400px">{{dataView.currencyAccountBalance}}</el-form-item>
                <el-form-item label="项目状态：" style="width: 400px">{{dataView.state | stateFormat}}</el-form-item>
            </el-form>

            <div>
                <h1 style="display: inline-block">订单列表</h1>
                <div style="float: right">
                    <el-select v-model="queryParams.states" placeholder="请选择订单状态"
                               style="width: 200px;margin-left: 20px">
                        <el-option v-for="item in incubatorOrderStatusEnum" :key="item.code" :value="item.value"
                                   :label="item.label"/>
                    </el-select>
                    <el-input v-model="queryParams.userId" maxlength="100" placeholder="用户ID"
                              style="width: 350px"></el-input>
                    <el-button type="primary" @click="searchIncubatorOrder">查 询</el-button>
                    <el-button type="primary" @click="exportIncubatorOrder">导 出</el-button>
                </div>
                <div style="border-bottom: 1px solid gainsboro"></div>
            </div>
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="orderList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="订单ID"></el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="payAmount" label="投入数量"
                                 v-if="dataView.incubatorType=='INVESTMENT'"></el-table-column>
                <el-table-column prop="incubatorAmount" label="买入数量"
                                 v-if="dataView.incubatorType=='SECKILL'"></el-table-column>
                <el-table-column prop="coinAmount" label="秒杀数量"
                                 v-if="dataView.incubatorType=='SECKILL'"></el-table-column>
                <el-table-column label="实际获得/团购数量" v-if="dataView.incubatorType=='GROUPBUYING'">
                    <template slot-scope="scope">
                        <span>{{scope.row.coinAmount}}/{{scope.row.incubatorAmount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="payCoin" label="支付币种"></el-table-column>
                <el-table-column prop="payAmount" label="支付数量"></el-table-column>
                <el-table-column prop="remark" label="备注">
                    <template slot-scope="scope">
                        <el-button @click="seeFormDataDialog(scope.row.remark)">查看表单</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.status | orderStateFormat}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>

            <span slot="footer" class="dialog-footer">
                <div style="width: 100%;text-align: center">
                    <el-button type="primary" @click="toggleOrderDialogVisible(false)">关 闭</el-button>
                </div>
             </span>
        </el-dialog>

        <el-dialog title="平台秒杀" width="600px" :visible="msDialogVisible" @close="closeMsDialog"
                   :close-on-click-modal="false">
            <el-form label-width="120px" inline>
                <el-form-item label="平台获得：" style="width: 200px">
                    {{dataView.platformAmount}}
                </el-form-item>
                <el-form-item label="剩余数量：" style="width: 200px">
                    {{dataView.surplusAmount}}
                </el-form-item>
                <el-form-item label="当前进度：" style="width: 200px">
                    {{(dataView.currentProgress*100).toFixed(2)}}%
                </el-form-item>
                <el-form-item label="目标进度：" style="width: 200px">
                    {{(dataView.targetProgress*100).toFixed(2)}}%
                </el-form-item>
            </el-form>
            <el-form label-width="120px" :model="opParams" :rules="opParamsRules" ref="opParamsForm">
                <el-form-item label="支付币种：" prop="coinType">
                    <el-autocomplete class="inline-input" v-model="opParams.coinType"
                                     :fetch-suggestions="querySearch" placeholder="请选择支付币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="秒杀数量：" prop="amount">
                    <el-input placeholder="请输秒杀数量" maxlength="70" v-model="opParams.amount"
                              style="width: 300px"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="msDialogVisible=false">关 闭</el-button>
                <el-button type="primary" @click="platformSnapUp">确 定</el-button>
             </span>
        </el-dialog>

        <el-dialog title="平台团购" width="600px" :visible="tgDialogVisible" @close="closeTgDialog"
                   :close-on-click-modal="false">
            <el-form label-width="120px" inline>
                <el-form-item label="平台获得：" style="width: 200px">
                    {{dataView.platformAmount}}
                </el-form-item>
                <el-form-item label="待注入：" style="width: 200px">
                    {{dataView.toBeInjected}}
                </el-form-item>
                <el-form-item label="当前进度：" style="width: 200px">
                    {{(dataView.currentProgress*100).toFixed(2)}}%
                </el-form-item>
                <el-form-item label="目标进度：" style="width: 200px">
                    {{(dataView.targetProgress*100).toFixed(2)}}%
                </el-form-item>
            </el-form>
            <el-form label-width="120px" :model="opParams" :rules="opParamsRules" ref="opParamsForm">
                <el-form-item label="支付币种：" prop="coinType">
                    <el-autocomplete class="inline-input" v-model="opParams.coinType"
                                     :fetch-suggestions="querySearch" placeholder="请选择支付币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="秒杀数量：" prop="amount">
                    <el-input placeholder="请输秒杀数量" maxlength="70" v-model="opParams.amount"
                              style="width: 300px"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="tgDialogVisible=false">关 闭</el-button>
                <el-button type="primary" @click="platformWaterFlooding">确 定</el-button>
             </span>
        </el-dialog>

        <el-dialog title="发放代币" width="600px" :visible="ffDialogVisible" @close="closeffDialog" @open="openffDialog"
                   :close-on-click-modal="false">
            <el-form label-width="120px" inline>
                <el-form-item label="待发放：" style="width: 200px">
                    {{ffData.toBeIssued}}
                </el-form-item>
                <el-form-item label="用户获得：" style="width: 200px">
                    {{ffData.userAmount}}
                </el-form-item>
                <el-form-item label="参与人数：" style="width: 200px">
                    {{ffData.peopleNumber}}
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ffDialogVisible=false">关 闭</el-button>
                <el-button type="primary" @click="issueTokens">确 定</el-button>
             </span>
        </el-dialog>

        <el-dialog title="查看表单" width="1000px" :visible="formDataDialogVisible"
                   :close-on-click-modal="false" @close="closeFormDialog">
            <el-form label-width="120px">
                <el-form-item label="表单：" style="margin-top: 20px">
                    <div v-for="item in formData" :key="item.id" style="margin-bottom: 10px">
                        <div>
                            <el-checkbox v-model="item.must" style="margin-right: 10px" :disabled="true">必答
                            </el-checkbox>
                            <el-input placeholder="请输入题目" maxlength="500" v-model="item.title"
                                      style="width: 460px" :disabled="true"></el-input>
                            <el-select v-model="item.answerType" placeholder="请选择回答方式" style="width: 150px"
                                       :disabled="true">
                                <el-option v-for="aType in formAnswerType" :key="aType.code" :label="aType.label"
                                           :value="aType.value"></el-option>
                            </el-select>
                        </div>

                        <div v-if="item.answerType=='RADIO' || item.answerType=='CHECKBOX'">
                            <div v-for="option in item.option" :key="option.id"
                                 style="margin-top: 10px">
                                <el-input placeholder="序号" maxlength="10" v-model="option.tag" :disabled="true"
                                          style="width: 100px"></el-input>
                                <el-input placeholder="请输入选项" maxlength="500" v-model="option.content"
                                          style="width: 425px"></el-input>
                            </div>
                        </div>
                        <div>用户答案:{{item.userAnswer}}</div>
                    </div>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <div style="width: 100%;text-align: center">
                    <el-button @click="formDataDialogVisible=false">关 闭</el-button>
                </div>
             </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import {mapState, mapMutations, mapActions, mapGetters} from "vuex";
    import {
        INCUBATOR_TYPE_ENUM,
        INCUBATOR_STATUS_ENUM,
        INCUBATOR_ORDER_STATUS_ENUM,
        FORM_ANSWER_TYPE
    } from "../constants";

    export default {
        name: "OrderListIncubator",
        data() {
            return {
                dataView: {
                    incubatorName: "",
                    incubatorCoin: "",
                    incubatorType: "SECKILL",
                    distributionType: "",
                    totalAmount: 0,
                    actualTotalAmount: 0,
                    paymentCoin: "",
                    discountCoin: "",
                    nowAmount: 0,
                    userAmount: 0,
                    platformAmount: 0,
                    surplusAmount: 0,
                    toBeInjected: 0,
                    currentProgress: 0,
                    targetProgress: 0,
                    currencyAccountBalance: 0,
                    state: 0,
                    updateTime: ""
                },
                orderList: [],
                total: 0,
                queryParams: {
                    incubatorId: "",
                    userId: "",
                    states: "",
                    page: 1,
                    size: 10,
                },
                opParams: {id: "", coinType: "", amount: ""},
                opParamsRules: {
                    "coinType": [{required: true, message: "请选支付币种"}],
                    "amount": [
                        {pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, message: "请输入数字"},
                        {required: true, message: '请输入秒杀数量'}
                    ]
                },
                timer: null,
                incubatorOrderStatusEnum: INCUBATOR_ORDER_STATUS_ENUM,
                msDialogVisible: false,
                tgDialogVisible: false,
                ffDialogVisible: false,
                formDataDialogVisible: false,
                ffData: {
                    toBeIssued: 0,
                    userAmount: 0,
                    peopleNumber: 0
                },
                formData: [{
                    id: (new Date()).getTime(),
                    title: "",
                    must: false,
                    answerType: "",
                    userAnswer: "",
                    correctAnswer: "",
                    option: [{id: (new Date()).getTime(), tag: "", content: ""}]
                }],
                opCoin: [],
                formAnswerType: FORM_ANSWER_TYPE
            }
        },
        computed: {
            ...mapState("IncubatorManage", ["orderDialogVisible", "currId", "coinTypes", "pairTypes", "country", "chain"])
        },
        filters: {
            stateFormat(val) {
                return INCUBATOR_STATUS_ENUM[val].label;
            },
            orderStateFormat(val) {
                return INCUBATOR_ORDER_STATUS_ENUM[val].label;
            },
            incubatorTypeFormat(val) {
                return INCUBATOR_TYPE_ENUM.find(x => x.value == val).name;
            },
            arrFormat(val) {
                if (val) {
                    let arr = JSON.parse(val);
                    return arr.join(",");
                } else {
                    return "";
                }
            }
        },
        methods: {
            ...mapMutations("IncubatorManage", ["toggleOrderDialogVisible"]),
            ...mapActions("IncubatorManage", ["setCurrId"]),
            openDialog() {
                this.getIncubatorDataView();
                this.getIncubatorOrderList();
                this.setTimeData();
            },
            closeDialog() {
                clearTimeout(this.timer);
                this.setCurrId(null);
                this.toggleOrderDialogVisible(false);
            },
            closeMsDialog() {
                this.$refs["opParamsForm"].resetFields();
                this.msDialogVisible = false;
            },
            closeTgDialog() {
                this.$refs["opParamsForm"].resetFields();
                this.tgDialogVisible = false;
            },
            closeffDialog() {
                this.ffData = {
                    toBeIssued: 0,
                    userAmount: 0,
                    peopleNumber: 0
                };
                this.ffDialogVisible = false;
            },
            openffDialog() {
                api.getIssueTokensInfo({id: this.currId}).then(({data}) => {
                    this.ffData = {...data};
                });
            },
            seeFormDataDialog(remark) {
                this.formData = remark ? JSON.parse(remark) : this.formData;
                this.formDataDialogVisible = true;
            },
            closeFormDialog() {
                this.formData = [{
                    id: (new Date()).getTime(),
                    title: "",
                    must: false,
                    answerType: "",
                    userAnswer: "",
                    correctAnswer: "",
                    option: [{id: (new Date()).getTime(), tag: "", content: ""}]
                }];
                this.formDataDialogVisible = false;
            },
            setTimeData() {
                api.getIncubatorDataView({id: this.currId}).then(({data}) => {
                    this.dataView = {...data};
                    let amount = this.opParams.amount ? this.opParams.amount : 0;
                    this.dataView.targetProgress = (Number(this.dataView.nowAmount) + Number(amount)) / Number(this.dataView.actualTotalAmount);
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        this.setTimeData();
                    }, 2000);
                });
            },
            getIncubatorDataView() {
                api.getIncubatorDataView({id: this.currId}).then(({data}) => {
                    this.dataView = {...data};
                    let arr1 = JSON.parse(data.paymentCoin);
                    let arr2 = JSON.parse(data.discountCoin);
                    this.opCoin = arr1.concat(arr2);
                });
            },
            searchIncubatorOrder() {
                this.queryParams.page = 1;
                this.getIncubatorOrderList();
            },
            exportIncubatorOrder() {
                this.queryParams.incubatorId = this.currId;
                api.exportIncubatorOrderRecord(this.queryParams).then(response => {
                    const fileName = "活动订单表.xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            getIncubatorOrderList() {
                this.queryParams.incubatorId = this.currId;
                api.getIncubatorOrderListByPage(this.queryParams).then(({data}) => {
                    this.orderList = data.records;
                    this.total = data.total;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getIncubatorOrderList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getIncubatorOrderList();
            },
            platformSnapUp() {
                this.$refs['opParamsForm'].validate(valid => {
                    if (valid) {
                        this.opParams.id = this.currId;
                        api.platformSnapUp(this.opParams).then(({data}) => {
                            this.$message.success('平台秒杀成功！');
                            this.getIncubatorOrderList();
                        });
                    }
                });
            },
            platformWaterFlooding() {
                this.$refs['opParamsForm'].validate(valid => {
                    if (valid) {
                        this.opParams.id = this.currId;
                        api.platformWaterFlooding(this.opParams).then(({data}) => {
                            this.$message.success('平台团购成功！');
                            this.getIncubatorOrderList();
                        });
                    }
                });
            },
            checkIncubator() {
                this.$confirm('确认进行检查吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.checkIncubator({id: this.currId}).then(({data}) => {
                        this.$message.success('检查成功！');
                        this.getIncubatorOrderList();
                    });
                }).catch(() => {
                });
            },
            calculationIncubator() {
                this.$confirm('确认进行核算吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.calculationIncubator({id: this.currId}).then(({data}) => {
                        this.$message.success('核算成功！');
                        this.getIncubatorOrderList();
                    });
                }).catch(() => {
                });
            },
            issueTokens() {
                api.issueTokens({id: this.currId}).then(({data}) => {
                    this.$message.success('发放成功！');
                    this.getIncubatorOrderList();
                });
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.opCoin;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.opCoin;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanCoin() {
                this.opParams.coinType = '';
            }
        },
        created() {

        }
    }
</script>

<style type="text/css">

</style>